import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPointSection } from './components/PainPointSection';
import { SolutionSection } from './components/SolutionSection';
import { ChaptersSection } from './components/ChaptersSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ForWhoSection } from './components/ForWhoSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-cream font-sans text-gray-900 overflow-x-hidden selection:bg-burgundy selection:text-cream" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainPointSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <ChaptersSection data-id="element-4" />
      <TestimonialsSection data-id="element-5" />
      <ForWhoSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <Footer data-id="element-8" />
    </main>;
}